import React from 'react';
import { StyleSheet } from 'react-native';

import Theme from '../../theme';
import { Icon } from '../../components';

const SuccessfulIndicator = ({
  size = 40,
}) => (
  <Icon
    size={size}
    color={Theme.GREEN}
    name="ios-checkmark-circle-outline"
    style={styles.container}
  />
)

const styles = StyleSheet.create({
  container: {
    padding: 5,
  },
});

export default SuccessfulIndicator;
